module.exports = __webpack_public_path__ + "img/pencil.b0972be3.svg";